/* eslint-disable max-len */
import React from 'react';

const NewInvoiceIcon: React.FC = () => {
	return (
		<svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M10.2129 4.66406H14.9757L10.2129 0.21875V4.66406Z" fill="#001B74"/>
			<path d="M8.30804 6.44219V0.21875H2.59263C2.08739 0.21875 1.60285 0.406089 1.24558 0.739551C0.888301 1.07301 0.6875 1.52529 0.6875 1.99687V16.2219C0.6875 16.6935 0.888301 17.1457 1.24558 17.4793C1.60285 17.8127 2.08739 18 2.59263 18H14.0234C14.5287 18 15.0132 17.8127 15.3705 17.4793C15.7278 17.1457 15.9286 16.6935 15.9286 16.2219V6.44219H8.30804Z" fill="#001B74"/>
		</svg>

	);
};

export default NewInvoiceIcon;
